exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".table .table-row{border-bottom:1px solid #ededed}.table.hover .table-row:hover{background-color:#ededed}.table .sortable-column{cursor:pointer}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/postcss-loader/lib?{"ident":"postcss"}!./node_modules/sass-loader/dist/cjs.js!./src/components/Table/TableRow/style.scss
// module id = 6503
// module chunks = 0